<template>
    <div class="flexed">
        <main-menu></main-menu>
        <div class="wrapper">
            <main-header></main-header>
            <companies></companies>
            <videos></videos>
            <articles></articles>
            <awards></awards>
            <books></books>
            <social></social>
            <footer-cmp></footer-cmp>
        </div>
    </div>
</template>


<script>
import MainHeader from './sections/Header'
import Companies from './sections/Companies'
import Awards from './sections/Awards'
import Social from './sections/Social'
import Books from './sections/Books'
import Menu from './sections/Menu'
import Videos from './sections/Videos'
import Footer from './sections/Footer'
import Articles from './sections/Articles'


export default {
  components: {
    'main-menu': Menu,
    'main-header': MainHeader,
    'companies': Companies,
    'videos': Videos,
    'articles':Articles,
    'awards': Awards,
    'social': Social,
    'books': Books,
    'footer-cmp':Footer
  },
  data () {
      return {
        
      }
  },
  methods: {
  }
}
</script>
<style lang="scss">
@font-face {
    font-family: 'kufi-regular';
    src: url('../assets/fonts/DroidKufi-Regular.ttf');
}
@font-face {
    font-family: 'kufi-bold';
    src: url('../assets/fonts/DroidKufi-Bold.ttf');
}
@font-face {
    font-family: 'bukra-light';
    src: url('../assets/fonts/Bukra-Light.ttf');
    src: url('../assets/fonts/Bukra-Light.woff') format('woff');
}
@font-face {
    font-family: 'bukra-medium';
    src: url('../assets/fonts/Bukra-Medium.ttf');
    src: url('../assets/fonts/Bukra-Medium.woff') format('woff');
}
@font-face {
    font-family: 'bukra-regular';
    src: url('../assets/fonts/Bukra-Regular.ttf');
    src: url('../assets/fonts/Bukra-Regular.woff') format('woff');
}
.flexed{
    display: flex;
}
.v-select{
    font-family: 'bukra-medium';
    width: 370px;
    .dropdown-toggle{
        background:white;
    }
}
.load-more{
    background: white;
    color:#3a80fe;
    width: 200px;
    font-family: 'bukra-medium';
    margin: 50px auto;
    height: 40px;
    text-align: center;
    padding-top: 12px;
    border-radius: 40px;
    width: 250px;
    cursor: pointer;
    box-shadow: 0px 0px 31px rgba(0,0,0,0.1);
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue